<template>
  <section class="ProductRelated" v-if="productsRelated.length > 0">
    <div class="Product-menuTarget" data-links="produits similaires" id="relateds"></div>
    <div class="container">
      <div class="Separator-title">Produits <span>similaires</span></div>
      <div class="ProductRelated-List">
        <VueSlickCarousel class="ProductRelated-slider" v-bind="settings">
          <ProductCard
            v-for="(productRelated, index) in productsRelated"
            :key="index"
            :propProductRelated="productRelated"
          ></ProductCard>
        </VueSlickCarousel>
      </div>
    </div>
  </section>
</template>

<script>
import ProductCard from "@/includes/Product/ProductCard/ProductCard.vue";
import VueSlickCarousel from "vue-slick-carousel";
import { mapGetters } from "vuex";

import "@/components/Product/ProductRelated/ProductRelated.scss";

export default {
  name: "ProductRelated",

  components: {
    ProductCard,
    VueSlickCarousel,
  },

  data() {
    return {
      settings: {
        arrows: true,
        dots: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        touchMove: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 639,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters({ productsRelated: "getProductsRelated" }),
  },
};
</script>
